import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import styles from './confirm.scss';
import { Warning } from '../../helpers/icon-dictionary';
import messages from './messages';
import SvgIcon from '../svg-icon/svg-icon';
import Button from '../button/index';
import { DARK } from '../button/variants';
import withModal from '../with-modal';

class ChangeCourseConfirmationWithTasks extends Component {
    constructor(props) {
        super(props);
        this.handleCarryOver = this.handleCarryOver.bind(this);
    }

    handleCarryOver(isCarryOver) {
        this.props.changeCourseCarryOver({ ...this.props, isCarryOver });
    }

    render() {
        const { changeCourseAssignedTasks, backToChangeCourse, intl, isChangingCourseCarryOverInProgress } = this.props;
        const header = intl.formatMessage(messages.confirmWithActivitiesHeader, { length: changeCourseAssignedTasks.length });

        return (
            <div>
                <div className={styles.changeCourseContainer}>
                    <div className={styles.icon}>
                        <SvgIcon icon={Warning} />
                    </div>
                    <div className={styles.header}>
                        <div>{header}</div>
                        {intl.formatMessage(messages.confirmWithActivitiesSubHeader)}
                    </div>
                    <div className={styles.buttons}>
                        <Button
                            disabled={isChangingCourseCarryOverInProgress}
                            handleOnClick={backToChangeCourse}
                            label={intl.formatMessage(messages.backLabel)}
                            variant={DARK} />
                        <Button
                            disabled={isChangingCourseCarryOverInProgress}
                            handleOnClick={() => this.handleCarryOver(false)}
                            label={intl.formatMessage(messages.noLabel)}
                            variant={DARK} />
                        <Button
                            disabled={isChangingCourseCarryOverInProgress}
                            handleOnClick={() => this.handleCarryOver(true)}
                            label={intl.formatMessage(messages.yesLabel)}
                            variant={DARK} />
                    </div>
                </div>
            </div>
        );
    }
}


ChangeCourseConfirmationWithTasks.propTypes = {
    backToChangeCourse: PropTypes.func,
    changeCourseAssignedTasks: PropTypes.array,
    changeCourseCarryOver: PropTypes.func,
    intl: intlShape.isRequired,
    isChangingCourseCarryOverInProgress: PropTypes.bool
};

const ChangeCourseConfirmationWithTasksIntl = injectIntl(
    styleable(styles)(ChangeCourseConfirmationWithTasks)
);
export default withModal('isActive')(ChangeCourseConfirmationWithTasksIntl);



// WEBPACK FOOTER //
// ./app/components/change-course/activity-confirmation.js